import React from 'react';
import PropTypes from 'prop-types';
import { compose, withState, lifecycle, withHandlers } from 'recompose';
import { StickySearch } from 'components/search/StickySearch';
import { JumpNav } from '../../plp/JumpNav/JumpNav';
import { Container } from 'components/core/Page';

import './StickyBar.scss';

const enhance = compose(
	withState('isVisible', 'setIsVisible', false),
	withHandlers({
		handleScroll: (props) => () => {
			if (window.scrollY > 300) {
				props.setIsVisible(true);
			} else {
				props.setIsVisible(false);
			}
		},
	}),
	lifecycle({
		componentDidMount() {
			window.addEventListener('scroll', this.props.handleScroll);
		},
		componentWillUnmount() {
			window.removeEventListener('scroll', this.props.handleScroll);
		},
	}),
);

export function StickyBar({
	isVisible,
	activeLink,
	handleLinkClick,
	handleSearch,
}) {
	return (
		<div className={`sticky-compo ${isVisible ? 'visible' : ''}`}>
			<StickySearch
				sticky
				horizontal
				onSearch={handleSearch}
			/>
			<div className="jump-nav">
				<Container>
					<JumpNav
						activeLink={activeLink}
						handleLinkClick={handleLinkClick}
					/>
				</Container>
			</div>
		</div>
	);
}

StickyBar.propTypes = {
	isVisible: PropTypes.bool.isRequired,
	activeLink: PropTypes.string,
	handleLinkClick: PropTypes.func.isRequired,
	handleSearch: PropTypes.func.isRequired,
};

export default enhance(StickyBar);
